/**
 * Created by nijin on 5/12/16.
 */

import {Component, OnInit} from '@angular/core';
import {ToastService, ToastData} from "./toast.service";

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls : ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
    toasts: Array<ToastData> = [];
    constructor(private toastService: ToastService) { }

    ngOnInit() {
        this.toastService.getToastData()
          .subscribe((toast: ToastData) => {this._setTimeout(toast); this.toasts.push(toast); });
    }


  private _setTimeout(toast: ToastData) {
    window.setTimeout(() => {
      this.clear(toast.id);
    }, toast.timeout);
  }

  clear(id: number) {
    if (id) {
      this.toasts.forEach((value: any, key: number) => {
        if (value.id === id) {
          this.toasts.splice(key, 1);
        }
      });
    } else {
      throw new Error('Please provide id of Toast to close');
    }
  }
 close(toast: ToastData) {
      this.clear(toast.id);
 }

}



// WEBPACK FOOTER //
// ./src/app/core/toast/toast.component.ts